var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('b-row', [_vm.$permissionAbility(_vm.LEAD_DASHBOARD_STATUS_WIDGET, _vm.permissions) ? _c('b-col', {
    staticClass: "mb-3",
    attrs: {
      "cols": "12",
      "md": "7"
    }
  }, [_c('LeadByStatusChart', {
    key: _vm.viewAs,
    attrs: {
      "view-as": _vm.viewAs,
      "filter-emp-id": _vm.selectedEmpId
    },
    on: {
      "update:filter-emp-id": function updateFilterEmpId($event) {
        _vm.selectedEmpId = $event;
      }
    }
  })], 1) : _vm._e(), _c('b-col', {
    attrs: {
      "cols": "12",
      "md": "5"
    }
  }, [_c('b-button-group', {
    staticClass: "w-100 d-flex justify-content-between"
  }, [_c('b-button', {
    attrs: {
      "variant": _vm.viewAs === 'employee' ? 'primary' : 'outline-primary'
    },
    on: {
      "click": function click($event) {
        _vm.viewAs = 'employee';
      }
    }
  }, [_vm._v(" My Lead ")]), _c('b-button', {
    attrs: {
      "variant": _vm.viewAs === 'manager' ? 'primary' : 'outline-primary'
    },
    on: {
      "click": function click($event) {
        _vm.viewAs = 'manager';
      }
    }
  }, [_vm._v(" Manager (KAM) ")]), _vm.$permissionAbility(_vm.LEAD_DASHBOARD_VIEW_AS_ADMIN, _vm.permissions) ? _c('b-button', {
    attrs: {
      "variant": _vm.viewAs === 'admin' ? 'primary' : 'outline-primary'
    },
    on: {
      "click": function click($event) {
        _vm.viewAs = 'admin';
        _vm.selectedEmpId = '';
      }
    }
  }, [_vm._v(" Admin ")]) : _vm._e()], 1), _vm.viewAs === 'admin' ? _c('div', {
    staticClass: "mt-1 max-w-md mx-auto bg-white rounded-xl shadow-md p-2"
  }, [_c('v-select', {
    staticClass: "w-full",
    attrs: {
      "options": _vm.employeeOptions,
      "reduce": function reduce(emp) {
        return emp.id;
      },
      "label": "name",
      "placeholder": "Select Employee"
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(user) {
        return [_c('UserSelect', {
          attrs: {
            "user": user
          }
        })];
      }
    }], null, false, 735027299),
    model: {
      value: _vm.selectedEmpId,
      callback: function callback($$v) {
        _vm.selectedEmpId = $$v;
      },
      expression: "selectedEmpId"
    }
  })], 1) : _vm._e(), _c('div', {
    staticClass: "mt-2"
  }, [_vm.$permissionAbility(_vm.LEAD_DASHBOARD_ACTIVITY_LOG, _vm.permissions) ? _c('DashboardActivityLog', {
    key: _vm.viewAs,
    attrs: {
      "view-as": _vm.viewAs,
      "selected-user-id": _vm.selectedEmpId
    },
    on: {
      "update:selected-user-id": function updateSelectedUserId($event) {
        _vm.selectedEmpId = $event;
      }
    }
  }) : _vm._e()], 1)], 1), _c('b-col', {
    staticClass: "px-5",
    attrs: {
      "cols": "12"
    }
  }, [_c('b-row', [_vm.$permissionAbility(_vm.LEAD_DASHBOARD_UPCOMING_APPOINTMENT, _vm.permissions) ? _c('b-col', {
    staticClass: "mb-3",
    attrs: {
      "cols": "12",
      "sm": "4"
    }
  }, [_c('LeadUpcomingAppointment', {
    key: _vm.viewAs,
    attrs: {
      "view-as": _vm.viewAs,
      "selected-user-id": _vm.selectedEmpId
    },
    on: {
      "update:selected-user-id": function updateSelectedUserId($event) {
        _vm.selectedEmpId = $event;
      }
    }
  })], 1) : _vm._e(), _vm.$permissionAbility(_vm.LEAD_DASHBOARD_TODAY_APPOINTMENT, _vm.permissions) ? _c('b-col', {
    staticClass: "mb-3",
    attrs: {
      "cols": "12",
      "sm": "4"
    }
  }, [_c('LeadTodayAppointment', {
    key: _vm.viewAs,
    attrs: {
      "view-as": _vm.viewAs,
      "selected-user-id": _vm.selectedEmpId
    },
    on: {
      "update:selected-user-id": function updateSelectedUserId($event) {
        _vm.selectedEmpId = $event;
      }
    }
  })], 1) : _vm._e(), _vm.$permissionAbility(_vm.LEAD_DASHBOARD_OVERDUE_APPOINTMENT, _vm.permissions) ? _c('b-col', {
    staticClass: "mb-3",
    attrs: {
      "cols": "4"
    }
  }, [_c('LeadOverDueAppointment', {
    key: _vm.viewAs,
    attrs: {
      "view-as": _vm.viewAs,
      "selected-user-id": _vm.selectedEmpId
    },
    on: {
      "update:selected-user-id": function updateSelectedUserId($event) {
        _vm.selectedEmpId = $event;
      }
    }
  })], 1) : _vm._e()], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }